// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import { Label, Box, Text } from 'gestalt';

type Props = {|
  alignTop?: boolean,
  children?: React.Node,
  label: React.Node,
  labelId?: string,
|};

type FormLabelProps = {|
  label: React.Node,
  labelId?: string,
|};

const FormLabel = ({ label, labelId }: FormLabelProps) =>
  labelId ? (
    <Label htmlFor={labelId}>
      <Text size="sm">{label}</Text>
    </Label>
  ) : (
    <Text size="sm">{label}</Text>
  );

export default function BoardFormRow(props: Props) {
  const { alignTop, children, label, labelId } = props;
  return (
    <Box
      alignItems={alignTop ? 'stretch' : 'center'}
      deprecatedPadding={{ x: 2, y: 3 }}
      display="flex"
      wrap
    >
      <Box paddingY={3} paddingX={1} xs={{ column: 12 }} md={{ column: 3 }}>
        <FormLabel label={label} labelId={labelId} />
      </Box>

      <Box xs={{ column: 12 }} md={{ column: 9 }}>
        {children}
      </Box>
    </Box>
  );
}

BoardFormRow.propTypes = {
  alignTop: PropTypes.bool,
  children: PropTypes.node,
  labelId: PropTypes.string,
  label: PropTypes.node,
};
